// On users_progress/{class_id}/time, the last timestamp is saved in object format
// Function returns the object in seconds
export default ({ second = 0, minute = 0, hour = 0 } = {}) =>
  second + minute * 60 + hour * 3600;
